import { PLATFORM } from 'aurelia-pal';

export const NAVIGATION = {
  avatar: [
    {
      name: 'logout',
      route: ['logout'],
      moduleId: PLATFORM.moduleName('libs/oac/containers/logout/logout.container', 'auth'),
      title: 'Logout',
      settings: {
        hideMenu: true,
      },
    },
  ],
  main: [],
  sub: [
    {
      name: 'help',
      route: ['help'],
      moduleId: PLATFORM.moduleName(
        'modules/search/containers/searchSection/searchSection.container',
        'searchSection',
      ),
      title: 'Help',
    },
  ],
  unmapped: [
    {
      name: 'home',
      route: [''],
      moduleId: PLATFORM.moduleName(
        'modules/search/containers/searchSection/searchSection.container',
        'searchSection',
      ),
      title: 'Activities',
    },
    {
      name: 'login',
      route: ['login'],
      moduleId: PLATFORM.moduleName('libs/oac/containers/login/login.container', 'auth'),
      title: 'Login',
      settings: {
        hideMenu: true,
        requiresAuthorization: false,
      },
    },
  ],
};
